<template>
  <div class="container">
    <el-tabs v-model="activeName">
      <el-tab-pane
        label="前台页面"
        name="/operate/pageManage/front"
      ></el-tab-pane>
      <el-tab-pane
        label="个人后台页面"
        name="/operate/pageManage/personalAfter"
      ></el-tab-pane>
    </el-tabs>
    <router-view />
  </div>
</template>

<script>
export default {
  data() {
    return {
      activeName: this.$route.path,
    };
  },
  methods: {},
  mounted() {},
  watch: {
    activeName: {
      handler(val, ovl) {
        this.$router.push(val);
      },
    },
    $route(to, from) {
      //监听路由是否变化
      this.activeName = to.path;
      if (to.query.key != from.query.key) {
        this.activeName = to;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.level_warp {
  .mantle {
    &:first-child {
      position: relative;
      &::before {
        top: 0;
        content: "";
        width: 1px;
        height: 50%;
        position: absolute;
        background-color: #ffffff;
      }
    }
    &:last-child {
      position: relative;
      &::after {
        content: "";
        width: 1px;
        bottom: 0;
        position: absolute;
        height: calc(50% - 1px);
        background-color: #ffffff;
      }
    }
  }
}

.level_warp {
  display: flex;
  padding: 12px 0;
  align-items: center;

  .title {
    display: flex;
    padding: 10px;
    align-items: center;
    border: 1px solid $--color-primary;
    border-radius: $--border-radius-base;
    span {
      font-size: 0.75rem;
    }
  }

  .line {
    width: 60px;
    height: 1px;
    min-width: 30px;
    background-color: $--color-primary;
    &[class*="lower-level-line"] {
      max-width: 100px;
    }
  }

  .index-name {
    width: 170px;
    display: flex;
    padding: 4px 15px;
    align-items: center;
    border: 1px solid $--color-primary;
    span {
      font-size: 0.875rem;
    }
    .el-button {
      margin-left: auto;
    }
  }

  .level {
    position: relative;

    &::before {
      top: 0;
      left: 0;
      bottom: 0;
      content: "";
      width: 1px;
      position: absolute;
      background-color: $--color-primary;
    }
  }
  .score {
    height: 40px;
    padding: 0 24px;
    line-height: 40px;
    font-size: 0.875rem;
    border: 1px solid $--color-primary;
    border-radius: $--border-radius-base;
  }
}
</style>